import * as React from 'react';
import { SaveDraftContainer } from '../SaveDraft';
import * as styles from './NeedIdentificationMobile.css';

export const NeedIdentificationMobile = () => {
  return (
    <div className={styles['wrapper']}>
      <SaveDraftContainer />
    </div>
  );
};
